(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lieblingsplatz-thanks"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialise = (root) => {
      root.querySelectorAll('[data-lp-thanks]').forEach((dialog) => {
        if (dialog.dataset.ready) return;
        dialog.dataset.ready = 'true';
        const open = () => {
          if (!dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
        };
        dialog.querySelectorAll('[data-lp-thanks-close]').forEach((button) => {
          button.addEventListener('click', () => dialog.close());
        });
        document.querySelectorAll('[data-lp-thanks-open]').forEach((button) => {
          if (button.dataset.lpThanksOpen === dialog.id) button.addEventListener('click', open);
        });
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        open();
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
    } else {
      initialise(document);
    }
    document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
